"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isNaN = function isNaN(value) {
  return value !== value;
};

var _default = isNaN;
exports.default = _default;